import Api from "@/configurations/Api";
import RequestService from "@/configurations/AxiosConfig";
import { ICheckpoint } from "@/types/type";
import { toast } from "sonner";

const endpoints = {
  checkpoints: 'checkpoints',
};

const CheckpointsService = {
  getCheckpointsByRouteId: async (id: string) => RequestService.get(`${endpoints.checkpoints}/route/${id}`),
  createCheckpoints: (data: Omit<ICheckpoint, 'id' | 'qr_code'>) => RequestService.post(endpoints.checkpoints, data),
  updateCheckpoints: async (data: Omit<ICheckpoint, 'qr_code'>) => RequestService.patch(`${endpoints.checkpoints}`, data),
  deleteCheckpoint: async (id: string | number) => RequestService.patch(`${endpoints.checkpoints}/delete/${id}`),
  deleteCheckListItem: async (id: string | number) => RequestService.patch(`${endpoints.checkpoints}/delete/checkListItem/${id}`),
  getCheckpointsPdfByRouteId: async (id: string | number) => {
    const response = await fetch(`${Api.getBaseUrl()}${endpoints.checkpoints}/qr-pdf/${id}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/pdf',
        'Accept': 'application/pdf',
        'Authorization': `${RequestService.defaults.headers.common.Authorization}`,
      }
    });
    if (!response.ok) {
      toast.error('Bir hata oluştu, lütfen daha sonra tekrar deneyin.');
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob); 
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `qr-pdf-${id}.pdf`);
    document.body.appendChild(link);
    link.click();
    return response
  }
};

export default CheckpointsService;
